export default __webpack_public_path__ + "static/media/done_circle.004deeaf.svg";